import Emitter from 'tiny-emitter/instance'

export const GlobalEventBus = Emitter